import select2 from 'select2';

export default function initializeForms() {
    initializeSelect2();
    select2Validation();
    fixFormLabels();
    fixFormRadio();
    fixFormCheckbox();
    fixFormAcceptance();
}

function fixFormAcceptance() {
    document.querySelectorAll('.wpcf7-acceptance:not(.optional)').forEach(function(element) {
        element.querySelector('input[type="checkbox"]').setAttribute('aria-required', true);
    });
}

function fixFormRadio() {
    document.querySelectorAll('.wpcf7-radio').forEach(function (element) {
        element.querySelectorAll('input[type="radio"]').forEach(function (radio, index) {
            radio.setAttribute('id', radio.closest('.wpcf7').id + '-radio-' + radio.closest('.wpcf7-radio').id + '-' + index);
        });

        element.querySelectorAll('label').forEach(function (label) {
            label.setAttribute('for', label.querySelector('input[type="radio"]').id);
        });
    });
}

function fixFormCheckbox() {
    document.querySelectorAll('.wpcf7-checkbox').forEach(function (element) {
        element.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox, index) {
            checkbox.setAttribute('id', checkbox.closest('.wpcf7').id + '-checkbox-' + checkbox.closest('.wpcf7-checkbox').id + '-' + index);
        });

        element.querySelectorAll('label').forEach(function (label) {
            label.setAttribute('for', label.querySelector('input[type="checkbox"]').id);
        });
    });
}

function fixFormLabels() {
    document.querySelectorAll('.wpcf7-acceptance').forEach(function (element) {
        element.querySelectorAll('label').forEach(function (label) {
            label.setAttribute('for', label.querySelector('input[type="checkbox"]').id);
        });
    });

    document.querySelectorAll('.honeypot').forEach(function (element) {
        element.querySelectorAll('.hp-message').forEach(function (label) {
            label.textContent = element.querySelector('.form__hp-label').textContent + ' ' + label.textContent;
        });
    });
}

function addStylesToFileInput() {
    let fileInputs = document.querySelectorAll('.wpcf7-file');

    fileInputs.forEach(function (input) {
        input.addEventListener('change', function () {
            let text = input.value.split('\\').pop();

            if (text === '') {
                text = 'Nie wybrano pliku';
            }

            input.closest('.form__file-container').querySelector('.form__file-label').innerHTML = text;
        })
    });
}

function addStylesToCheckboxes() {
    const labels = document.querySelectorAll('.wpcf7-list-item > label');

    labels.forEach(label => {
        label.addEventListener('click', e => {
            let checkbox = label.querySelector('input[type="checkbox"]');

            if (checkbox.checked === true) {
                label.classList.add('checked');
            } else {
                label.classList.remove('checked');
            }
        });
    });

    document.querySelectorAll('.wpcf7').forEach(function (form) {
        form.addEventListener('wpcf7mailsent', function (e) {
            event.currentTarget.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (select) {
                select.closest('label').classList.remove('checked');
            });
        })
    });
}

function initializeSelect2() {
    $('.wpcf7-select').each(function () {
        $(this).select2({
            language: 'pl',
            minimumResultsForSearch: Infinity,
        });
    });

    document.querySelectorAll('.select2-selection__rendered').forEach(item => {
        item.removeAttribute('role');
    });
}

function select2Validation() {
    let wpcf7Form = document.querySelectorAll('.wpcf7');

    wpcf7Form.forEach(form => {
        form.querySelector('.wpcf7-submit').addEventListener('click', function (event) {
            form.querySelectorAll('.select2').forEach(select2 => {
                select2.classList.remove('select2-container--not-valid');
            });
        }, false);

        form.addEventListener('wpcf7invalid', function (event) {
            form.querySelectorAll('select').forEach(select => {
                setTimeout(function () {
                    if (select.classList.contains('wpcf7-not-valid')) {
                        select.parentNode.querySelector('.select2').classList.add('select2-container--not-valid');
                    }
                }, 50)
            });
        }, false);
    });
}